import React from "react";
import { Alert, Button, CircularProgress } from "@mui/material";
import { WorkflowPifApplicantStatus } from "../../hooks/useWorkflowPifApplicant";

interface WorkflowPifApplicantBannerProps {
  status: WorkflowPifApplicantStatus;
  onRetry: () => void;
}

/**
 * Where saving a new hire's SSN to the applicant record stands (decision P4). It runs after pif-1's
 * submit, so this sits above whichever stage the case has moved on to. Nothing shows once it is
 * saved. The SSN itself is never shown or named here.
 */
const WorkflowPifApplicantBanner: React.FC<WorkflowPifApplicantBannerProps> = ({ status, onRetry }) => {
  if (status === "saving") {
    return (
      <Alert severity="info" className="workflow-run__alert" icon={<CircularProgress size={18} aria-hidden />}>
        Saving the applicant&apos;s identity…
      </Alert>
    );
  }
  if (status === "failed") {
    return (
      <Alert
        severity="error"
        className="workflow-run__alert"
        action={
          <Button color="inherit" size="small" onClick={onRetry}>
            Retry
          </Button>
        }
      >
        The applicant&apos;s SSN couldn&apos;t be saved. Retry before sending this PIF for approval.
      </Alert>
    );
  }
  if (status === "refused") {
    return (
      <Alert severity="error" className="workflow-run__alert">
        The applicant&apos;s SSN couldn&apos;t be saved to this case. Please contact HR.
      </Alert>
    );
  }
  return null;
};

export default WorkflowPifApplicantBanner;
